export default __webpack_public_path__ + "static/media/garlands4.c1cc9af5.png";